export default {
  // baseUrl: `http://localhost:8080/api/v1`,
  baseUrl: `https://api.evo22.ru/api/v1`,
}
